module.exports = __webpack_public_path__ + "img/portrait-082.0dba6ada.jpg";